import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Scroll to `#id` once the element exists. Lets other pages link straight to a
 * form whose content loads after the route renders.
 */
export const useScrollToHash = (id: string, ready: boolean) => {
  const { hash } = useLocation();

  useEffect(() => {
    if (ready && hash === `#${id}`) {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [hash, id, ready]);
};
